export const SEARCH_PLACEHOLDER = '궁금한 점을 검색해 보세요.';
